<script>
	import Icon from './Icon.svelte';
	export let value = null;
	export let id = '';
</script>

<div>
	<select {id} bind:value>
		<option value={null} selected disabled>Select option</option>
		<slot />
	</select>
	{#if value !== null}
		<!-- svelte-ignore a11y-click-events-have-key-events -->
		<span class="reset-select" on:click={() => (value = null)}>
			<Icon name="close" />
		</span>
	{/if}
</div>

<style>
	div {
		position: relative;
	}
	select {
		display: block;
		width: 100%;
		padding: 12px 6px;
		margin: 0.5em 0;
		border: 1px solid #727178;
		border-radius: 3px;
	}
	:global(.reset-select svg) {
		width: 15px;
		height: 15px;
	}
	.reset-select {
		position: absolute;
		top: 15px;
		right: 20px;
	}
</style>
